function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
import { ButtonIconAdd } from '@arc/frontend/ui-buttons';
import { typography } from '@arc/frontend/ui-theme';
const PAGE_HEADER_HEIGHT = 72;
export const pageHeaderAddButtonStyles = process.env.NODE_ENV === "production" ? {
  name: "14ib1ak",
  styles: "padding:0.5rem;margin-left:-0.5rem"
} : {
  name: "1m3j0e1-pageHeaderAddButtonStyles",
  styles: "padding:0.5rem;margin-left:-0.5rem;label:pageHeaderAddButtonStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
export const pageHeaderVerticalCenterStyles = /*#__PURE__*/css({
  display: 'flex',
  alignItems: 'center',
  minHeight: PAGE_HEADER_HEIGHT
}, process.env.NODE_ENV === "production" ? "" : ";label:pageHeaderVerticalCenterStyles;");
const styles = {
  pageHeader: /*#__PURE__*/css({
    // TODO: Remove this when top level layout is changed
    minHeight: PAGE_HEADER_HEIGHT,
    flexShrink: 0,
    display: 'flex',
    justifyContent: 'space-between',
    paddingLeft: '1rem',
    paddingRight: '1rem',
    gap: '1rem'
  }, process.env.NODE_ENV === "production" ? "" : ";label:pageHeader;"),
  headerLeft: align => /*#__PURE__*/css({
    display: 'flex',
    alignItems: align,
    gap: '1rem'
  }, process.env.NODE_ENV === "production" ? "" : ";label:headerLeft;"),
  headerRight: align => /*#__PURE__*/css({
    display: 'flex',
    alignItems: align,
    gap: '1.5rem'
  }, process.env.NODE_ENV === "production" ? "" : ";label:headerRight;"),
  addButton: pageHeaderAddButtonStyles
};
export function PageHeader({
  title,
  onAddClick,
  addDisabled,
  leftSlot,
  align = 'center',
  testid,
  children,
  leftStyles,
  rightStyles,
  containerStyles,
  customLayout
}) {
  const verticalCenter = align === 'center' ? x => x : x => <div css={pageHeaderVerticalCenterStyles}>{x}</div>;
  return <header css={[styles.pageHeader, containerStyles, process.env.NODE_ENV === "production" ? "" : ";label:PageHeader;"]} data-testid={testid}>
			<div css={[styles.headerLeft(align), leftStyles, process.env.NODE_ENV === "production" ? "" : ";label:PageHeader;"]}>
				{verticalCenter(<h1 css={typography.title}>{title}</h1>)}

				{onAddClick ? verticalCenter(<ButtonIconAdd onClick={onAddClick} css={styles.addButton} data-disabled={addDisabled} />) : null}
				{leftSlot}
			</div>

			{customLayout ? children : <div css={[styles.headerRight(align), rightStyles, process.env.NODE_ENV === "production" ? "" : ";label:PageHeader;"]}>{children}</div>}
		</header>;
}